import { DirectorSearchFilter } from '../../models/directorSearchFilter';

export interface IDirectorListState {
  searchFilter: DirectorSearchFilter;
  currentPage: number;
  pageSize: number;
  sortBy: string;
  ascending: boolean;
}

export const initialDirectorListState: IDirectorListState = {
  searchFilter: {},
  currentPage: 1,
  pageSize: 10,
  sortBy: 'fullName',
  ascending: true
};
